import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=a63621ec"
import script from "./Evaluations.vue?vue&type=script&lang=js"
export * from "./Evaluations.vue?vue&type=script&lang=js"
import style0 from "./Evaluations.vue?vue&type=style&index=0&id=a63621ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports